class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.hoverCloseTimer = null;

    this.addEventListener('mouseenter', () => {
      if (!this.supportsDesktopHover()) return;
      this.cancelHoverClose();
      this.openForHover();
    });

    this.addEventListener('mouseleave', () => {
      if (!this.supportsDesktopHover()) return;
      this.cancelHoverClose();
      this.hoverCloseTimer = setTimeout(() => {
        if (this.contains(document.activeElement) && document.activeElement !== this.summary) return;
        this.close();
      }, 170);
    });

    this.summary.addEventListener('click', (event) => {
      if (!this.supportsDesktopHover() || event.detail === 0) return;
      event.preventDefault();
      this.openForHover();
    });
  }

  supportsDesktopHover() {
    return window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
  }

  cancelHoverClose() {
    if (this.hoverCloseTimer !== null) {
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = null;
    }
  }

  openForHover() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach((item) => {
      if (item !== this && item.mainDetailsToggle?.open) item.close();
    });
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  disconnectedCallback() {
    this.cancelHoverClose();
  }
}

customElements.define('header-menu', HeaderMenu);
